export const FIRMWARE_TYPE = {
    SWITCH_DEVICE_IMAGE: "SWITCH_DEVICE_IMAGE",
    SWITCH_STM_IMAGE: "SWITCH_STM_IMAGE",
    WIFI_IMAGE: "WIFI_IMAGE",
    AC_DEVICE_IMAGE: "AC_DEVICE_IMAGE",
    PCB_IMAGE: "PCB_IMAGE"
}
export const FILTER = {
    USERID: "USERID",
    PREMISEID: "PREMISEID",
    DEVICEID: "DEVICEID",
    EVENT: "EVENT",
    SEVERITY: "SEVERITY",
    ACCOUNTID: "ACCOUNTID"
}
export const NAVTYPE = {
    SCHEDULES: "schedules",
    SCENES: "scenes",
    GROUPS: "groups",
    GLOBAL_SETTINGS: "global_settings"
}    

export const IDLE_TIMER = {
    TIMEOUT : 18000000, // Timeout after 5 hours
    DEBOUNCE : 250
}


export const BUILD_TYPE = {
    SWITCH_FIRMWARE_BUILD: "SWITCH_FIRMWARE_BUILD",
    SWITCH_IMAGE_BUILD: "SWITCH_IMAGE_BUILD",
    PAC_FIRMWARE_BUILD: "PAC_FIRMWARE_BUILD"
};


export const SUBSCRIPTION = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
}


export const SECURITY_SERVICE_NAME= {
    NONE: "NONE",
    DIY: "DIY",
    CONTEXTUAL:"CONTEXTUAL"
}


export const GRAPHS_SERVICE_NAME = {
    NONE: "NONE",
    AGGREGATED: "AGGREGATED",
    COMPLETE: "COMPLETE"
}

export const ADVANCE_GROUPING_SERVICE_NAME = {
    NONE: "NONE",
    BASIC: "BASIC",
    ADVANCE: "ADVANCE"
}

export const HUMIDITY_SERVICE_NAME = {
    NONE: "NONE",
    HUMIDITY: "HUMIDITY"
}


export const SECURITY_SERVICE= {
    NONE: 0,
    DIY: 1,
    CONTEXTUAL: 2
}


export const GRAPHS_SERVICE = {
    NONE: 0,
    AGGREGATED: 1,
    COMPLETE: 2
}

export const ADVANCE_GROUPING_SERVICE = {
    NONE: 0,
    BASIC: 1,
    ADVANCE: 2
}

export const HUMIDITY_SERVICE = {
    NONE: 0,
    HUMIDITY: 1
}

export const CERTIFICATE_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
}

export const MAC_LENGTH =12;